<template>
    <div class="p-2 p-lg-5">
        <div class="row">
            <div class="col-6 ps-4 ms-2">
                <h2>{{ $t("titles.transportations") }}</h2>
            </div>
            <div v-if="$store.getters.hasPerm('add_transportation')" class="col-auto ms-auto">
                <router-link :to="{ name: 'AddTransportation' }" class="button-top">
                    {{ $t("transportations.addTransportation") }}
                </router-link>
            </div>
        </div>
        <Table endpoint="/transportations" ref="table" class="mt-3">
            <template v-slot:header>
                <div class="col-3 col-lg-2">{{ $t("orders.id") }}</div>
                <div class="col-2">{{ $t("transportations.date") }}</div>
                <div class="col-2 text-break">{{ $t("transportations.recipient") }}</div>
                <div class="col-2 text-break phone-number">{{ $t("transportations.subscriber") }}</div>
            </template>
            <template #row="line">
                <div class="col-3 col-lg-2">
                    <span>{{ line.item.id }}</span>
                </div>
                <div class="col-2">
                    <span v-if="line.item.date">{{ line.item.date }}</span>
                    <span v-else>-</span>
                </div>
                <div class="col-2 text-break">
                    <span v-if="line.item.recipient">{{ line.item.recipient.name }}</span>
                    <span v-else>-</span>
                </div>
                <div class="col-2 text-break phone-number">
                    <span v-if="line.item.subscriber">{{ line.item.subscriber.name }}</span>
                    <span v-else>-</span>
                </div>
                <router-link :to="'/transportation/' + line.item.id" class="col-3 col-lg-1 mt-4 mt-lg-0">
                    <span>{{ $t("utils.detail") }}</span>
                </router-link>
            </template>
        </Table>
    </div>
</template>
<script>
import Table from "@/components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {

        }
    },

}
</script>
<style scoped lang="scss">
</style>